import { useI18n, type StringKey } from '../lib/i18n';
import { useMarkNotificationsRead, useNotifications } from '../lib/queries';
import { Card } from './ui';

/**
 * Template keys the worker writes. Anything not listed is skipped rather than
 * shown as a raw key, so a half-deployed template never reaches a customer.
 */
const TEMPLATES: Record<string, StringKey> = {
  'tier.upgraded': 'notif.tier.upgraded',
  'reward.issued': 'notif.reward.issued',
  'referral.paid': 'notif.referral.paid',
};

export function Notifications() {
  const { t } = useI18n();
  const { data } = useNotifications();
  const markRead = useMarkNotificationsRead();

  const unread = (data?.items ?? []).filter(
    (item) => item.readAt === null && TEMPLATES[item.templateKey],
  );
  if (unread.length === 0) return null;

  return (
    <Card className="border-brand/30 bg-brand-wash">
      <h2 className="mb-2 text-[0.68rem] font-semibold uppercase tracking-[0.18em] text-brand">
        {t('notif.title')}
      </h2>
      <ul className="space-y-1.5">
        {unread.map((item) => (
          <li key={item.id} className="text-sm leading-relaxed text-ink">
            {t(TEMPLATES[item.templateKey]!, item.params ?? undefined)}
          </li>
        ))}
      </ul>
      <button
        onClick={() => markRead.mutate()}
        disabled={markRead.isPending}
        className="mt-3 min-h-11 w-full rounded-xl border border-brand/35 text-sm font-semibold text-brand transition-colors hover:bg-brand/15 disabled:opacity-50"
      >
        {t('notif.markRead')}
      </button>
    </Card>
  );
}
